import { useEffect, useState } from 'react'
import { useRegisterManager } from '../../../../ng-compat/hooks'
import { US_COUNTRY_CODE } from '../../../../vend-ui/constants'
import {
  autotaxSettingsStore,
  AutotaxSettings,
} from '../../../../factories/database/autotax-settings-store'

export type { AutotaxSettings }

/**
 * Manages autotax settings (e.g. isDeliveryTaxEnabled).
 *
 * On mount, hydrates from IndexedDB for an instant cached value.
 * Updates automatically when the sync cycle detects a version bump
 * for autotax_settings via /api/2.0/versions.
 */
export const useAutotaxSettings = (): AutotaxSettings => {
  const registerManager = useRegisterManager()
  const [isDeliveryTaxEnabled, setIsDeliveryTaxEnabled] = useState(false)
  const currentOutlet = registerManager.getActiveOutlet()
  const isUSOutlet = currentOutlet?.physical_country_id === US_COUNTRY_CODE

  useEffect(() => {
    if (!isUSOutlet) return

    let cancelled = false

    const updateFromStore = () => {
      autotaxSettingsStore.get().then(settings => {
        if (!cancelled && settings?.isDeliveryTaxEnabled !== undefined) {
          setIsDeliveryTaxEnabled(settings.isDeliveryTaxEnabled)
        }
      })
    }

    updateFromStore()

    autotaxSettingsStore.on('sync', updateFromStore)

    return () => {
      cancelled = true
      autotaxSettingsStore.off('sync', updateFromStore)
    }
  }, [isUSOutlet])

  return { isDeliveryTaxEnabled }
}
